module.exports = __webpack_public_path__ + "static/media/t7.4e1979a2.png";